import React from 'react';
import styled from 'astroturf/react';

import $image_url from 'js/utils/image_url';
import { getDurationString } from 'js/videos/shared/video_helper';

const Container = styled.div`
  position: relative;
  flex: none;
  width: 120px;
  height: 88px;
  margin-right: 10px;
  background: #fffff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-sizing: content-box;
`;

const ThumbnailImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const PlayIcon = styled.img`
  position: absolute;
  width: 40px;
  height: 40px;
  top: calc(50% - 20px);
  left: calc(50% - 20px);
`;

const Duration = styled.span`
  position: absolute;
  bottom: 2px;
  right: 2px;
  color: #ffffff;
  background-color: #000000;
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  padding: 2px;
`;

const Thumbnail: React.FunctionComponent<{
  url: string;
  duration?: number;
  ContainerComponent?: React.ComponentType;
}> = ({ url, duration, ContainerComponent = Container }) => (
  <ContainerComponent>
    <ThumbnailImage src={url} alt="" />
    <PlayIcon src={$image_url('video-play-icon.svg')} alt="" />
    {duration && <Duration>{getDurationString(duration)}</Duration>}
  </ContainerComponent>
);

export default Thumbnail;
